export const ROUTE_PATHS = {
  HOME: '/',
} as const;

export interface ContactInfo {
  company: string;
  location: string;
  email: string;
  phone: string;
  website?: string;
  socialMedia?: {
    facebook?: string;
    linkedin?: string;
    instagram?: string;
  };
}

export interface SDGGoal {
  number: number;
  title: string;
  description: string;
  icon: string;
}

export const SECTION_IDS = {
  HERO: 'hero',
  SOBRE: 'sobre',
  MODELO_OPERACIONAL: 'modelo-operacional',
  SUSTENTABILIDADE: 'sustentabilidade',
  INTEGRACAO_TERRITORIAL: 'integracao-territorial',
  COMPROMISSO: 'compromisso',
  CONTACTO: 'contacto',
} as const;

export type SectionId = typeof SECTION_IDS[keyof typeof SECTION_IDS];
